<script setup lang="ts">
import { UiButton, UiTooltip } from '@shopexperts/shared';

/**
 * Action button that explains itself: when disabled, the exact blocking
 * reason (mirroring the API guard) is shown as a tooltip.
 */
const props = defineProps<{
  label: string;
  variant?: 'primary' | 'secondary' | 'ghost' | 'outline' | 'danger';
  /** Non-null disables the button and becomes the tooltip content. */
  disabledReason?: string | null;
  loading?: boolean;
}>();

const emit = defineEmits<{
  click: [];
}>();
</script>

<template>
  <UiTooltip v-if="props.disabledReason" :content="props.disabledReason">
    <!-- Disabled buttons swallow mouse events; the span carries the hover. -->
    <span class="inline-flex w-full">
      <UiButton
        :label="props.label"
        :variant="props.variant ?? 'outline'"
        size="md"
        disabled
        class="w-full pointer-events-none"
      />
    </span>
  </UiTooltip>
  <UiButton
    v-else
    :label="props.label"
    :variant="props.variant ?? 'outline'"
    size="md"
    :disabled="props.loading"
    class="w-full"
    @click="emit('click')"
  />
</template>
